export default {
	"ability": {
		"warning": "预警",
		"checkTime": "提前审单时间(时)",
		"pickupTime": "提货迟到预警(时)",
		"backTime": "回单时间(天)",
		"schedulingTime": "提前调度时间(时)",
		"deliveryTime": "送货迟到预警(时)",
		"continuous": "连续",
		"tips1": "次温度预警会通知其直属上级",
		"gpsOutPush": "GPS回传频率(分)",
		"customerExceptionTime": "客户反馈时效(天)",
		"transportTips": "运输订单接入",
		"lightRate": "泡重比",
		"orderMerge": "单据明细相同SKU是否自动合并",
		"singleTrial": "审单",
		"manualOrImportOrder": "手工新建、导入的订单允许关闭",
		"interfaceOrder": "其他系统对接订单允许关闭",
		"optionOrderStatus": "允许撤销审核、关闭操作的业务点是",
		"notScheduling": "未调度",
		"notPickUp": "未提货",
		"orderMustProject": "下单必须要产品/项目",
		"pushOrderAutoMatch": "接口推单自动匹配站点",
		"billingTips": "计费",
		"billingPoint": "运输订单最迟生成计费业务点",
		"none": "无控制",
		"dispatched": "调度",
		"routeBusinessBillingPoint": "派车单最迟生成计费业务点",
		"billingLogDebug": "计费记录详细日志",
		"planTips": "计划",
		"routeTempComposeRule": "创建派车单温度有交集",
		"confirmGrouporder": "在线单据自动生成派车单",
		"ms": "多任务+单任务",
		"m": "多任务",
		"routeTimeComposeRule": "创建派车单时间有交集",
		"mixFullLoadRatio": "满载率下限",
		"maxFullLoadRatio": "满载率上限",
		"subsequentProcessing": "审单时对整车单的后续自动操作",
		"n": "不处理",
		"c": "生成派车单",
		"cc": "生成派车单并确认",
		"autoPlanSenderAddress": "围栏范围内的发货点进行聚合排线",
		"trialStrategy": "排线试算策略",
		"scheduling": "调度日期相同",
		"pScheduleRouteMustProject": "调度必须要产品/项目",
		"pDispatchVehicleReminder": "调度重复车辆提醒方式",
		"departure": "发车日期相同",
		"pDispatchingOfflineCarrierCapacity": "调度线下承运商运力信息",
		"mb": "必须",
		"dmb": "不必须",
		"pUnscheduledDocumentSwitch": "允许承运商查看未调度单据",
		"perform": "执行",
		"pContinueShortMessageOnOnlineuser": "发送站内消息后继续发送短信",
		"pGpsMonitorNode": "后跟踪车辆GPS",
		"pTerminalShowExpFeedbackCsh": "移动端展示异常联系电话",
		"pTerminalShowCsh": "移动端显示客服电话",
		"pTerminalShowCshTel": "客服电话",
		"pAppointment": "预约",
		"prebookPickupCapacityRequired": "提货预约时一定需要运力信息",
		"prebookDeliveryCapacityRequired": "送货预约时一定需要运力信息",
		"mustPrebook": "能与其他系统预约的单据必须预约",
		"pMustDeliverByOtherSystem": "与其他系统预约的单据必须由其他系统发货",
		"pPushCapacityToUp": "运力完全同步到上游",
		"pNeedMsgForReserve": "预约时需要发送消息",
		"sendPickTips3": "提送货",
		"pPickupInforNeededTakePhoto": "提货信息采集必须拍照",
		"pDeliveryInforNeededTakePhoto": "到货信息采集必须拍照",
		"pNeedConfirmDelivery": "下游送货完成需确认",
		"pInterfaceSyncTransDataOp": "同步发运接口数据同步方式勾选同步数据且发货反选仅同步数据",
		"pDeliverySignAddressExceptionReason": "范围外送货必须填写原因",
		"pH5PickupDataEditableOnApiSync": "同步发运数据后支持司机更改提货数量",
		"pH5WorkingCollectMode1": "有明细单据按照",
		"pH5WorkingCollectMode2": "异常提送货",
		"wechatAndWeb": "小程序/公众号",
		"pScanPickupUploadPic": "公众号提货信息采集必须拍照",
		"pScanDeliveryUploadPic": "公众号送货信息采集必须拍照",
		"pScanPickupDeliveryConfirm": "公众号采集的数据需要确认",
		"pH5PickupCapacityEditable": "公众号提货时可以更改车辆信息",
		"pScanPickupedVehicleTemperature": "公众号提货必须测试车温",
		"pScanPickupedGoodsTemperature": "公众号提货必须测试货温",
		"pScanReceivedGoodsTemperature": "公众号收货必须测试货温",
		"pBetweenReceivedAndSignedRate": "最快揽收签收间隔时间",
		"pPickupWaitDedaultTime": "发运默认免费等待时间(分钟)",
		"pTransferPrintMaxNumber": "标签打印限制条数",
		"pAutoDeliveryBuffer": "自动送货完成缓冲时间(小时)",
		"monitortips": "监控",
		"pDetentionGpsTimes": "默认地点范围大小",
		"pVehicleStayTimeMax": "异常提送货",
		"abilityTipsCarrier": "必须存在对承运报价才能接入单据",
		"upStreamOrder": "上游货主推送订单",
		"restingTime": "Resting Time",
		"minWorkingHourAlert": "minimum working hour alert (minutes)",
		"maxWorkingHourAlert": "maximum working hour alert (minutes)",
		"alertForOverWorkHour": "alert when over working hour (minutes)",
		"minRestingTimeDuration": "minimum resting time duration (minutes)",
		"maxRestingTimeDuration": "maximum resting time duration (minutes)",
		"alertBeforeEndingMaxRestingTime": "alert before ending maximum resting time (minutes)",
		"distanceOfNearbyRestStop": "distance of nearby rest Stop (kilometres)",
		"invalidMinWorkingHourAlert": "Invalid minimum working hour alert",
		"invalidMaxWorkingHourAlert": "Invalid maximum working hour alert",
		"invalidAlertForOverWorkHour": "Invalid alert when over working hour",
		"invalidMinRestingTimeDuration": "Invalid minimum resting time duration",
		"invalidMaxRestingTimeDuration": "Invalid maximum resting time duration",
		"invalidAlertBeforeEndingMaxRestingTime": "Invalid alert before ending maximum resting time",
		"invalidDistanceOfNearbyRestStop": "Invalid distance of nearby rest Stop",
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/ability/ability.js